import React from "react";

const Checkbox = ({ label, checked, id, setChecked }) => {
  const handleChange = () => setChecked(!checked);

  return (
    <div className={"check-wrapper"}>
      <input
        onChange={handleChange}
        checked={checked}
        type="checkbox"
        id={id}
		className={'visually-hidden'}
      />
      <label htmlFor={id} dangerouslySetInnerHTML={{ __html: label }}></label>
    </div>
  );
};

export default Checkbox;
